import { Link, Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, type Me } from "./lib/api";

export function App() {
  const nav = useNavigate();
  const { data: me, isLoading } = useQuery<Me | null>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await api.me();
      } catch {
        return null;
      }
    },
  });

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="font-semibold">AI Adoption</Link>
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/" className="hover:underline">Home</Link>
            {me ? (
              <>
                <Link to="/weekly" className="hover:underline">Weekly</Link>
                <Link to="/wins/mine" className="hover:underline">My wins</Link>
                {me.roles.includes("manager") || me.roles.includes("strategist") || me.roles.includes("ceo") ? (
                  <Link to="/attest" className="hover:underline">Attest</Link>
                ) : null}
                {me.roles.includes("champion") || me.roles.includes("strategist") || me.roles.includes("ceo") ? (
                  <>
                    <Link to="/dashboard" className="hover:underline">Dashboard</Link>
                    <Link to="/leaderboard" className="hover:underline">Leaderboard</Link>
                  </>
                ) : null}
                {me.roles.includes("strategist") || me.roles.includes("ceo") ? (
                  <div className="relative group">
                    <button className="hover:underline">Admin ▾</button>
                    <div className="absolute right-0 mt-1 hidden group-hover:block bg-white border rounded shadow text-sm">
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/roster">Roster</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/pilot-candidates">Pilot candidates</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/pilot-cohort">Pilot cohort</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/champions">Champions</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/playbook-edits">Playbook edits</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/commitments">Commitments</Link>
                      <div className="border-t my-1" />
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/digest-preview">Monday digest</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/preread/ceo-retro">CEO retro pre-read</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/preread/champion-forum">Champion forum pre-read</Link>
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/preread/90day">90-day brief</Link>
                      <div className="border-t my-1" />
                      <Link className="block px-3 py-1 hover:bg-slate-50" to="/admin/ops">Ops · health · audit</Link>
                    </div>
                  </div>
                ) : null}
              </>
            ) : null}
            {isLoading ? null : me ? (
              <button
                className="text-slate-600 hover:underline"
                onClick={async () => {
                  await api.logout();
                  nav("/login");
                }}
              >
                Sign out · {me.email}
              </button>
            ) : (
              <Link to="/login" className="hover:underline">Sign in</Link>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-5xl mx-auto px-4 py-6">
          <Outlet />
        </div>
      </main>

      <footer className="border-t border-slate-200 text-xs text-slate-500 py-3">
        <div className="max-w-5xl mx-auto px-4">AI Adoption Platform · planning repo at /home/ubuntu/team-ai-adoption</div>
      </footer>
    </div>
  );
}
